import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from 'classnames';
import { useState } from 'react';
export const Alert = (props) => {
    const { children, className, dismissable, variant, onDismiss, ...rest } = props;
    const classes = classnames('pds-alert', `pds-alert-${variant}`, className);
    const [dismissed, setDismissed] = useState(false);
    if (dismissed)
        return null;
    function dismiss() {
        onDismiss?.();
        setDismissed(true);
    }
    function dismissButton() {
        if (!dismissable)
            return null;
        return (_jsx("button", { type: "button", className: "pds-alert-close", "aria-label": "Dismiss Alert", onClick: dismiss, children: "Dismiss" }));
    }
    return (_jsxs("div", { role: "alert", className: classes, ...rest, children: [_jsx("span", { children: children }), dismissButton()] }));
};
